const testingReducer = {}

export default testingReducer